import { isString } from '../utils/is';
export function shouldIgnoreEvent(patterns, msg) {
    return patterns.some((pattern) => {
        return isString(pattern) ? msg.includes(pattern) : !!msg.match(pattern);
    });
}
